import { configureStore } from "@reduxjs/toolkit";
import adminReducer from "./slices/adminSlice";
import collectionsReducer from "./slices/collectionsSlice";

export const store = configureStore({
  reducer: {
    admin: adminReducer,
    collections: collectionsReducer,
  },
});

export default store;
